const tabsPopup = {
    currentStage: ''
};

export default tabsPopup;